import { render, staticRenderFns } from "./Profile-Password-Update.vue?vue&type=template&id=f30ec3dc&scoped=true&"
import script from "./Profile-Password-Update.vue?vue&type=script&lang=js&"
export * from "./Profile-Password-Update.vue?vue&type=script&lang=js&"
import style0 from "./Profile-Password-Update.vue?vue&type=style&index=0&id=f30ec3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30ec3dc",
  null
  
)

export default component.exports